module.exports = __webpack_public_path__ + "img/1_uk.34f511b6.svg";